module.exports = __webpack_public_path__ + "img/google-earth-mission-blue-02.45c02fa2.jpg";